<!--
 - Bcx page header component HTML
 -
 - @version
 - 4.70.0 OAUI-678 Build "Driver Assignment" UI
 -
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 - @copyright (c) 2024 Build Centrix
 -->
<header class="bcx-page-header">
  <div class="row">
    <div class="col-sm-6 bcx-header-titles">
      <div class="bcx-header-subtitle">{{pageSubtitle}}</div>
      <div class="bcx-header-title">{{pageTitle}}</div>
    </div>
    <div class="col-sm-6 bcx-header-content">
      <!--Notifications Button-->
      <div class="bcx-header-content-item">
        <ng-content select="[notifications-button]"></ng-content>
      </div>
      <!--Filters Button-->
      <div class="bcx-header-content-item">
        <ng-content select="[filters-button]"></ng-content>
      </div>
      <!--Exports Button-->
      <div class="bcx-header-content-item">
        <ng-content select="[exports-button]"></ng-content>
      </div>
      <!--Add Button-->
      <div class="bcx-header-content-item">
        <ng-content select="[add-button]"></ng-content>
      </div>
    </div>
  </div>
</header>
